import { render, staticRenderFns } from "./AuthDialog.vue?vue&type=template&id=a51911ba&scoped=true"
import script from "./AuthDialog.vue?vue&type=script&lang=js"
export * from "./AuthDialog.vue?vue&type=script&lang=js"
import style0 from "./AuthDialog.vue?vue&type=style&index=0&id=a51911ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51911ba",
  null
  
)

export default component.exports